import React from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

export default function Sidebar() {
  const navigate = useNavigate();

  // ======================================check for language=======================================

  const ingerman = useSelector((state) => state.homedata.selectedLang);
  console.log(ingerman, "lang");

  const handleActive = () => {
    const element = document.getElementsByClassName("toggle-sidebar");
    if (element) {
      if (element[0]) {
        element[0].classList.remove("active");
      } else {
        element?.classList.remove("active");
      }
    }
  };
  return (
    <div className="sidebar">
      <div className="toggle-close-reps">
        <button onClick={handleActive}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M12.4825 11.0262L20.7215 2.83225C21.1165 2.44125 21.1165 1.80825 20.7215 1.41825C20.3275 1.02725 19.6875 1.02725 19.2935 1.41825L11.0615 9.60525L2.7535 1.29625C2.3595 0.90125 1.7195 0.90125 1.3255 1.29625C0.9315 1.69225 0.9315 2.33325 1.3255 2.72825L9.6275 11.0312L1.2955 19.3173C0.9015 19.7083 0.9015 20.3413 1.2955 20.7313C1.6895 21.1223 2.3295 21.1223 2.7235 20.7313L11.0485 12.4523L19.3235 20.7283C19.7175 21.1233 20.3575 21.1233 20.7515 20.7283C21.1455 20.3323 21.1455 19.6913 20.7515 19.2963L12.4825 11.0262Z"
              fill="#121313"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.2935 1.41813C19.6875 1.02713 20.3275 1.02713 20.7215 1.41813C21.1165 1.80813 21.1165 2.44113 20.7215 2.83213L12.4825 11.0261L20.7515 19.2961C21.1455 19.6911 21.1455 20.3321 20.7515 20.7281C20.3575 21.1231 19.7175 21.1231 19.3235 20.7281L11.0485 12.4521L2.7235 20.7311C2.3295 21.1221 1.6895 21.1221 1.2955 20.7311C0.9015 20.3411 0.9015 19.7081 1.2955 19.3171L9.6275 11.0311L1.3255 2.72813C0.9315 2.33313 0.9315 1.69213 1.3255 1.29613C1.7195 0.901128 2.3595 0.901128 2.7535 1.29613L11.0615 9.60513L19.2935 1.41813ZM11.0625 8.89897L18.9409 1.06361C19.5298 0.479231 20.4845 0.478762 21.0734 1.06296C21.6661 1.64878 21.6655 2.60044 21.074 3.18671M11.0625 8.89897L3.1075 0.943023C3.10758 0.943104 3.10742 0.942942 3.1075 0.943023C2.51812 0.352407 1.56078 0.352244 0.971499 0.943023C0.383674 1.53383 0.382588 2.49083 0.971499 3.08123L8.91944 11.0301L0.9433 18.9622C0.352637 19.5484 0.351829 20.5001 0.9433 21.086C1.53225 21.6705 2.48675 21.6705 3.0757 21.086L11.0475 13.1583L18.9695 21.0812C19.5589 21.6721 20.5161 21.6721 21.1055 21.0812C21.6933 20.4904 21.6944 19.5334 21.1055 18.943L13.1906 11.0271L21.0732 3.18748"
              fill="#121313"
            />
          </svg>
        </button>
      </div>
      <div className="logo-side">
        <div style={{cursor:"pointer"}} className="main-logo-here">
          <img onClick={()=>navigate("/")} src={require("../Assets/images/upd-logo.png")} />
        </div>
      </div>
      <hr />
      <div className="side-menu">
        <div>
          <div className="side-btm-space">
            <Link
              className={
                window.location.pathname == "/get-started"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
              to="/get-started"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10 0C4.50742 0 0 4.50742 0 10C0 15.4926 4.50742 20 10 20C15.4926 20 20 15.4926 20 10C20 4.50742 15.4926 0 10 0ZM11 14.6875C11 15.3335 10.646 15.8594 10 15.8594C9.35398 15.8594 9 15.3335 9 14.6875V8.82812C9 8.18211 9.35398 7.65625 10 7.65625C10.646 7.65625 11 8.18211 11 8.82812V14.6875ZM10 6.48438C9.35398 6.48438 8.82812 5.95852 8.82812 5.3125C8.82812 4.66648 9.35398 4.14062 10 4.14062C10.646 4.14062 11.1719 4.66648 11.1719 5.3125C11.1719 5.95852 10.646 6.48438 10 6.48438Z"
                  fill="#777D7B"
                />
              </svg>
              <p>{ingerman == "de" ? "Get Started" : "Get Started"}</p>
            </Link>
          </div>
          <div className="side-btm-space">
            <Link
              to="/reflection-journey-page"
              className={
                window.location.pathname == "/reflection-journey-page"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM7 8.01821C7 6.90819 7.90819 6 9.01821 6C10.1282 6 11.0364 6.90819 11.0364 8.01821V15.6369C11.0364 16.747 10.1282 17.6552 9.01821 17.6552C7.90819 17.6552 7 16.747 7 15.6369V8.01821ZM9.01821 16.4442C9.46221 16.4442 9.82549 16.081 9.82549 15.6369V8.01821C9.82549 7.5742 9.46221 7.21093 9.01821 7.21093C8.5742 7.21093 8.21093 7.5742 8.21093 8.01821V15.6369C8.21093 16.081 8.5742 16.4442 9.01821 16.4442ZM12.6523 8.01821C12.6523 6.90819 13.5605 6 14.6706 6C15.7806 6 16.6888 6.90819 16.6888 8.01821V15.6369C16.6888 16.747 15.7806 17.6552 14.6706 17.6552C13.5605 17.6552 12.6523 16.747 12.6523 15.6369V8.01821ZM14.6706 16.4442C15.1146 16.4442 15.4778 16.081 15.4778 15.6369V8.01821C15.4778 7.5742 15.1146 7.21093 14.6706 7.21093C14.2265 7.21093 13.8633 7.5742 13.8633 8.01821V15.6369C13.8633 16.081 14.2265 16.4442 14.6706 16.4442Z"
                  fill="#777D7C"
                />
              </svg>
              <p>{ingerman == "de" ? "Reflection" : "Reflection"}</p>
            </Link>
          </div>
          <div className="side-btm-space">
            <Link
              to="/meditation"
              className={
                window.location.pathname == "/meditation"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M24 20.4788V7.25376C24 5.31245 22.2651 3.73251 20.1312 3.73251H19.0713V3.52125C19.0713 1.57926 17.3364 0 15.2025 0H3.86879C1.73554 0 0 1.57926 0 3.52125V16.7462C0 18.6875 1.7356 20.2675 3.86879 20.2675H4.92859V20.4788C4.92859 22.4207 6.66419 24 8.79743 24H20.1312C22.2651 24 24 22.4208 24 20.4788ZM8.79743 22.8474C7.35966 22.8474 6.19471 21.7869 6.19471 20.4788V7.25376C6.19471 5.94563 7.35966 4.88518 8.79743 4.88518H20.1312C21.5689 4.88518 22.7339 5.94563 22.7339 7.25376V20.4788C22.7339 21.7869 21.5689 22.8474 20.1312 22.8474H8.79743Z"
                  fill="#777D7C"
                />
                <path
                  d="M8.36441 9.47356H18.4347C18.7129 9.47356 18.9381 9.25011 18.9381 8.97425C18.9381 8.69839 18.7129 8.475 18.4347 8.475H8.36441C8.08625 8.475 7.86094 8.69839 7.86094 8.97425C7.86094 9.25011 8.08625 9.47356 8.36441 9.47356Z"
                  fill="#ECF8F5"
                />
                <path
                  d="M9.95508 12.3664C9.95508 12.6423 10.181 12.8656 10.4592 12.8656H19.8958C20.174 12.8656 20.3999 12.6423 20.3999 12.3664C20.3999 12.0905 20.174 11.8664 19.8958 11.8664H10.4592C10.181 11.8664 9.95508 12.0905 9.95508 12.3664Z"
                  fill="#ECF8F5"
                />
                <path
                  d="M17.7122 15.7595C17.7122 15.4836 17.4868 15.2602 17.2087 15.2602H8.36441C8.08625 15.2602 7.86094 15.4836 7.86094 15.7595C7.86094 16.0353 8.08619 16.2594 8.36441 16.2594H17.2087C17.4868 16.2594 17.7122 16.0354 17.7122 15.7595Z"
                  fill="#ECF8F5"
                />
                <path
                  d="M20.399 19.1508C20.399 18.8749 20.1731 18.6516 19.8949 18.6516H11.607C11.3288 18.6516 11.1035 18.8749 11.1035 19.1508C11.1035 19.4267 11.3288 19.6501 11.607 19.6501H19.8949C20.1732 19.6501 20.399 19.4267 20.399 19.1508Z"
                  fill="#ECF8F5"
                />
              </svg>
              <p>{ingerman == "de" ? "Meditationen" : "Meditation"}</p>
            </Link>
          </div>
          <hr />
          <div className="side-btm-space">
            <Link
              to="/coaching"
              className={
                window.location.pathname == "/coaching"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="25"
                viewBox="0 0 20 25"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.0005 12.9827C11.4957 12.9827 12.9557 12.0838 14.1117 10.4516C15.1319 9.01122 15.7409 7.23031 15.7409 5.68769C15.7409 2.55151 13.1657 0 10.0005 0C6.8352 0 4.26004 2.55151 4.26004 5.68769C4.26004 7.23031 4.86904 9.01122 5.88922 10.4516C7.04519 12.0838 8.50526 12.9827 10.0005 12.9827ZM18.4121 15.5255C17.4007 13.9703 15.9768 12.7287 14.2943 11.9352C14.1155 11.8509 13.9028 11.887 13.7626 12.0255C12.6349 13.1397 11.3338 13.7286 10.0001 13.7286C8.66611 13.7286 7.36524 13.1397 6.23822 12.0255C6.09806 11.887 5.88514 11.8508 5.70648 11.9351C4.02394 12.7287 2.59988 13.9702 1.58831 15.5255C0.549218 17.123 0 18.9764 0 20.8853V20.8934C0 21.0242 0.0557894 21.149 0.153577 21.2369C2.36071 23.2202 5.09971 24.4752 8.01891 24.8676L9 18H11L11.9811 24.8676C14.9003 24.4752 17.6392 23.2202 19.8464 21.2369C19.9442 21.149 20 21.0243 20 20.8934V20.8853C20.0001 18.9764 19.451 17.123 18.4121 15.5255ZM12 14H8L9 17H11L12 14Z"
                  fill="#777D7C"
                />
              </svg>
              <p>Coaching</p>
            </Link>
          </div>

          <div className="side-btm-space">
            <Link
              to="/inbox"
              className={
                window.location.pathname == "/inbox"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="22"
                viewBox="0 0 24 22"
                fill="none"
              >
                <path
                  d="M24.0001 21.4455C23.6877 22.0691 23.2888 22.1641 22.7308 21.7475C21.5297 20.8507 20.3256 19.9586 19.1289 19.056C18.72 18.7475 18.2754 18.604 17.7731 18.6054C15.0316 18.6106 12.2901 18.608 9.54854 18.6073C7.86654 18.6067 6.70493 17.3955 6.70243 15.6408C6.7018 15.2333 6.70243 14.8253 6.70243 14.3812C6.8045 14.3812 6.89405 14.3812 6.98422 14.3812C9.49907 14.3812 12.0145 14.3857 14.5294 14.3798C16.4218 14.3753 18.0242 13.136 18.5321 11.2672C18.6398 10.8722 18.6893 10.4484 18.6955 10.0364C18.7156 8.68842 18.7031 7.3404 18.7031 5.99238C18.7031 5.9046 18.7031 5.81683 18.7031 5.70482C19.122 5.70482 19.5184 5.70024 19.9141 5.70613C20.5072 5.71465 21.1064 5.67469 21.6907 5.75526C22.8761 5.9177 23.7396 6.83604 23.9563 8.06943C23.9644 8.11659 23.9845 8.16179 23.9989 8.20764C24.0001 12.6198 24.0001 17.0327 24.0001 21.4455Z"
                  fill="#777D7C"
                />
                <path
                  d="M9.52846 0.00198443C11.8166 0.00198443 14.1054 0.00198443 16.3936 0.00198443C17.0592 0.00198443 17.2978 0.250235 17.2978 0.940621C17.2978 3.97138 17.2997 7.00213 17.2966 10.0329C17.2953 11.4025 16.4462 12.5226 15.1718 12.8298C14.9314 12.8881 14.6771 12.9051 14.4292 12.9058C11.6876 12.911 8.94671 12.913 6.20518 12.9051C5.70797 12.9038 5.27464 13.0479 4.87324 13.3505C3.64462 14.2761 2.41037 15.1938 1.17549 16.1108C0.702075 16.4625 0.124086 16.2595 0.015752 15.7073C-0.00303416 15.6123 0.000723081 15.5121 0.000723081 15.4145C9.68745e-05 11.2656 -0.000529332 7.11545 0.000723081 2.96527C0.00134929 1.22162 1.15357 0.00853458 2.82742 0.00329446C5.0611 -0.0032557 7.29478 0.00198443 9.52846 0.00198443ZM9.1208 5.47267C9.72196 5.47267 10.3225 5.47267 10.9236 5.47267C11.6726 5.47267 12.4222 5.47857 13.1711 5.4694C13.6151 5.46416 13.9226 5.09669 13.8756 4.65259C13.8336 4.25631 13.5249 4.00282 13.0728 4.00216C10.9186 4.00085 8.76449 4.00151 6.61033 4.00151C6.11062 4.00151 5.61154 4.0002 5.11182 4.00216C4.81625 4.00347 4.57955 4.12269 4.4374 4.40369C4.18253 4.90543 4.52319 5.46743 5.09366 5.47005C6.43562 5.4766 7.77821 5.47267 9.1208 5.47267ZM9.10514 8.90495C10.4008 8.90495 11.6964 8.90495 12.992 8.90495C13.0778 8.90495 13.1642 8.90692 13.2494 8.89906C13.5825 8.86696 13.8468 8.5912 13.8768 8.24863C13.9075 7.8995 13.7059 7.572 13.3884 7.47833C13.2776 7.44558 13.158 7.43641 13.0421 7.43641C10.4277 7.43444 7.81328 7.43444 5.19824 7.43641C5.08991 7.43641 4.95965 7.422 4.87825 7.47702C4.70917 7.59165 4.50941 7.71741 4.42362 7.89361C4.18629 8.37701 4.54949 8.90233 5.10243 8.9043C6.43562 8.90823 7.77007 8.90495 9.10514 8.90495Z"
                  fill="#777D7C"
                />
              </svg>

              <p>{ingerman == "de" ? "Inbox" : "Inbox"}</p>
            </Link>
          </div>
          <div className="side-btm-space">
            <Link
              to="/appointments"
              className={
                window.location.pathname == "/appointments"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="24"
                viewBox="0 0 22 24"
                fill="none"
              >
                <path
                  d="M16.5926 13.2H10.6667V19.2H16.5926V13.2ZM15.4074 0V2.4H5.92593V0H3.55556V2.4H2.37037C1.06074 2.4 0.0118518 3.474 0.0118518 4.8L0 21.6C0 22.926 1.06074 24 2.37037 24H18.963C20.2726 24 21.3333 22.926 21.3333 21.6V4.8C21.3333 3.474 20.2726 2.4 18.963 2.4H17.7778V0H15.4074ZM18.963 21.6H2.37037V8.4H18.963V21.6Z"
                  fill="#777D7C"
                />
              </svg>
              <p>{ingerman == "de" ? "Meine Termine" : "Your Appointment"}</p>
            </Link>
          </div>
          <hr />
          <div className="side-btm-space">
            <Link
              to="/my-profile"
              className={
                window.location.pathname == "/my-profile"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="24"
                viewBox="0 0 20 24"
                fill="none"
              >
                <path
                  d="M10.0267 14.2401C11.3361 14.2401 12.649 14.1684 13.9512 14.2537C17.1036 14.4585 19.7721 17.0799 19.9785 20.0972C20.0034 20.459 20.0212 20.8345 19.9464 21.186C19.7934 21.8926 19.3558 22.4216 18.6727 22.7391C17.5163 23.2749 16.2746 23.5241 15.015 23.6914C12.1758 24.0668 9.32936 24.0736 6.4794 23.8518C4.8534 23.7255 3.24162 23.4934 1.71168 22.8995C0.50552 22.4319 -0.0139477 21.7526 0.000284278 20.6501C0.0109583 19.8856 0.14972 19.1415 0.437918 18.4281C1.46618 15.875 3.98169 14.2094 6.83165 14.1991C7.89549 14.1957 8.96289 14.1991 10.0267 14.1991C10.0267 14.2094 10.0267 14.2264 10.0267 14.2401Z"
                  fill="#777D7C"
                />
                <path
                  d="M10.0089 11.7518C6.62172 11.7552 3.85716 9.1202 3.85004 5.88785C3.84648 2.63161 6.59326 0 10.0054 0C13.4175 0 16.1678 2.6282 16.1643 5.88444C16.1607 9.1202 13.3997 11.7518 10.0089 11.7518Z"
                  fill="#777D7C"
                />
              </svg>
              <p>{ingerman == "de" ? "Profil" : "Profile"}</p>
            </Link>
          </div>
          <div className="side-btm-space">
            <Link
              className={
                window.location.pathname == "/settings"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
              to="/settings"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M0.215634 12.0594C-0.0718781 10.7015 -0.0718781 9.29846 0.215634 7.94055C1.32534 8.07052 2.29507 7.70362 2.61099 6.93982C2.9279 6.17503 2.50302 5.23028 1.62525 4.53747C2.38209 3.37411 3.37411 2.38209 4.53747 1.62525C5.22928 2.50202 6.17503 2.9279 6.93982 2.61099C7.70462 2.29407 8.07152 1.32534 7.94055 0.215634C9.29846 -0.0718781 10.7015 -0.0718781 12.0594 0.215634C11.9295 1.32534 12.2964 2.29507 13.0602 2.61099C13.825 2.9279 14.7697 2.50302 15.4625 1.62525C16.6259 2.38209 17.6179 3.37411 18.3747 4.53747C17.498 5.22928 17.0721 6.17503 17.389 6.93982C17.7059 7.70462 18.6747 8.07152 19.7844 7.94055C20.0719 9.29846 20.0719 10.7015 19.7844 12.0594C18.6747 11.9295 17.7049 12.2964 17.389 13.0602C17.0721 13.825 17.497 14.7697 18.3747 15.4625C17.6179 16.6259 16.6259 17.6179 15.4625 18.3747C14.7707 17.498 13.825 17.0721 13.0602 17.389C12.2954 17.7059 11.9285 18.6747 12.0594 19.7844C10.7015 20.0719 9.29846 20.0719 7.94055 19.7844C8.07052 18.6747 7.70362 17.7049 6.93982 17.389C6.17503 17.0721 5.23028 17.497 4.53747 18.3747C3.37411 17.6179 2.38209 16.6259 1.62525 15.4625C2.50202 14.7707 2.9279 13.825 2.61099 13.0602C2.29407 12.2954 1.32534 11.9285 0.215634 12.0594ZM2.00215 10.2099C3.10186 10.5149 4.00861 11.2117 4.45849 12.2954C4.90737 13.3801 4.75841 14.5148 4.19656 15.5065C4.29254 15.6085 4.39151 15.7075 4.49348 15.8034C5.48621 15.2416 6.61991 15.0936 7.70462 15.5415C8.78833 15.9914 9.48514 16.8981 9.79006 17.9978C9.93002 18.0018 10.07 18.0018 10.2099 17.9978C10.5149 16.8981 11.2117 15.9914 12.2954 15.5415C13.3801 15.0926 14.5148 15.2416 15.5065 15.8034C15.6085 15.7075 15.7075 15.6085 15.8034 15.5065C15.2416 14.5138 15.0936 13.3801 15.5415 12.2954C15.9914 11.2117 16.8981 10.5149 17.9978 10.2099C18.0018 10.07 18.0018 9.93002 17.9978 9.79006C16.8981 9.48514 15.9914 8.78833 15.5415 7.70462C15.0926 6.61991 15.2416 5.48522 15.8034 4.49348C15.7071 4.39191 15.6081 4.2929 15.5065 4.19656C14.5138 4.75841 13.3801 4.90637 12.2954 4.45849C11.2117 4.00861 10.5149 3.10186 10.2099 2.00215C10.07 1.99845 9.92999 1.99845 9.79006 2.00215C9.48514 3.10186 8.78833 4.00861 7.70462 4.45849C6.61991 4.90737 5.48522 4.75841 4.49348 4.19656C4.39151 4.29254 4.29254 4.39151 4.19656 4.49348C4.75841 5.48621 4.90637 6.61991 4.45849 7.70462C4.00861 8.78833 3.10186 9.48514 2.00215 9.79006C1.99815 9.93002 1.99815 10.07 2.00215 10.2099ZM10 12.9992C9.20456 12.9992 8.44171 12.6832 7.87925 12.1207C7.31679 11.5583 7.00081 10.7954 7.00081 10C7.00081 9.20456 7.31679 8.44171 7.87925 7.87925C8.44171 7.31679 9.20456 7.00081 10 7.00081C10.7954 7.00081 11.5583 7.31679 12.1207 7.87925C12.6832 8.44171 12.9992 9.20456 12.9992 10C12.9992 10.7954 12.6832 11.5583 12.1207 12.1207C11.5583 12.6832 10.7954 12.9992 10 12.9992ZM10 10.9997C10.2651 10.9997 10.5194 10.8944 10.7069 10.7069C10.8944 10.5194 10.9997 10.2651 10.9997 10C10.9997 9.73485 10.8944 9.48057 10.7069 9.29308C10.5194 9.1056 10.2651 9.00027 10 9.00027C9.73485 9.00027 9.48057 9.1056 9.29308 9.29308C9.1056 9.48057 9.00027 9.73485 9.00027 10C9.00027 10.2651 9.1056 10.5194 9.29308 10.7069C9.48057 10.8944 9.73485 10.9997 10 10.9997Z"
                  fill="#777D7C"
                />
              </svg>
              <p>{ingerman == "de" ? "Einstellungen" : "Settings"}</p>
            </Link>
          </div>
          <div className="side-btm-space">
            <Link
              className={
                window.location.pathname == "/notification"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
              to="/notification"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="20"
                viewBox="0 0 17 20"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.2071 6.79633C15.2071 8.0523 15.539 8.7925 16.2695 9.6456C16.8231 10.2741 17 11.0808 17 11.956C17 12.8302 16.7128 13.6601 16.1373 14.3339C15.384 15.1417 14.3215 15.6573 13.2372 15.747C11.6659 15.8809 10.0937 15.9937 8.5005 15.9937C6.9063 15.9937 5.33505 15.9263 3.76375 15.747C2.67846 15.6573 1.61602 15.1417 0.86367 14.3339C0.28822 13.6601 0 12.8302 0 11.956C0 11.0808 0.1779 10.2741 0.73049 9.6456C1.48384 8.7925 1.79392 8.0523 1.79392 6.79633V6.3703C1.79392 4.68834 2.21333 3.58852 3.077 2.51186C4.36106 0.9417 6.41935 0 8.4558 0H8.5452C10.6254 0 12.7502 0.98702 14.0125 2.62466C14.8314 3.67916 15.2071 4.73265 15.2071 6.3703V6.79633ZM5.57367 18.0608C5.57367 17.5573 6.03582 17.3266 6.46318 17.2279C6.9631 17.1222 10.0093 17.1222 10.5092 17.2279C10.9366 17.3266 11.3987 17.5573 11.3987 18.0608C11.3738 18.5402 11.0926 18.9653 10.704 19.2352C10.2001 19.628 9.6088 19.8767 8.9906 19.9664C8.6487 20.0107 8.3128 20.0117 7.9828 19.9664C7.3636 19.8767 6.7723 19.628 6.26938 19.2342C5.87978 18.9653 5.59852 18.5402 5.57367 18.0608Z"
                  fill="#777D7C"
                />
              </svg>
              <p>{ingerman == "de" ? "Benachrichtigungen" : "Notifications"}</p>
            </Link>
          </div>
          <hr />
        </div>
        <div>
          <div className="side-btm-last">
            <div
              onClick={() => {
                navigate("/logout-page");
              }}
            >
              <Link
                className={
                  window.location.pathname == "/"
                    ? "menu-btn bar_active"
                    : "menu-btn btn-logout"
                }
              >
                <p>{ingerman == "de" ? "Ausloggen" : "Logout"}</p>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
